module.exports = __webpack_public_path__ + "static/img/fw1.1da5cf51.png";